export default "__VITE_ASSET__cc8a8720__"